import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import LegalAcceptPage from "@/pages/LegalAcceptPage";
import SubscriptionEndedPage from "@/pages/SubscriptionEndedPage";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="session-loading">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-amber-500" />
    </div>
  );
}

const OPEN_WITHOUT_PLAN = ["/suscripcion", "/bienvenida", "/pago/exito", "/admin"];

export function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.legal?.pending) return <LegalAcceptPage user={user} />;
  if (user.billing?.access === "ended" && !["/pago/exito", "/bienvenida"].includes(location.pathname)) return <SubscriptionEndedPage user={user} />;
  if (user.billing?.access === "none" && !OPEN_WITHOUT_PLAN.includes(location.pathname)) return <Navigate to="/suscripcion?auto=1" replace />;
  return <Outlet />;
}

export function PublicOnlyRoute() {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/resumen" replace />;
  return <Outlet />;
}

export function AdminRoute() {
  const { user } = useAuth();
  if (user && user.role === "admin") return <Outlet />;
  return (
    <div className="mx-auto max-w-xl py-16 text-left" data-testid="admin-forbidden">
      <ShieldAlert className="mb-4 h-10 w-10 text-rose-600" />
      <h1 className="font-display text-3xl font-extrabold text-slate-900">Acceso restringido</h1>
      <p className="mt-2 text-slate-600">Esta sección es solo para administradores.</p>
    </div>
  );
}
